import CategoryItem from "@/views/service-center/components/service-main/category-item";
import { FC } from "react";
import S from "./index.module.scss";
import { ServiceCenterPageCategoriesResource } from "@/api/generated-api";

interface ICategoriesList {
  categories: ServiceCenterPageCategoriesResource[];
}

const CategoriesList: FC<ICategoriesList> = ({ categories }) => {
  return (
    <div className={S.categoriesList}>
      {categories.map(category => (
        <CategoryItem key={category.id} category={category} />
      ))}
    </div>
  );
};

export default CategoriesList;
